import { render } from "./InviteView.vue?vue&type=template&id=4636821c&scoped=true"
import script from "./InviteView.vue?vue&type=script&lang=js"
export * from "./InviteView.vue?vue&type=script&lang=js"

import "./InviteView.vue?vue&type=style&index=0&id=4636821c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4636821c"]])

export default __exports__